import {
  getCheckoutChromeInput,
  getCheckoutChromeOutput,
} from "@redotech/redo-conversion-checkout-branding-common/rpc-schemas/get-checkout-chrome";
import { unaryRpc } from "@redotech/rpc/definition";

// Fetched by the shell on page load, in parallel with session state; the
// shell renders default chrome until (and unless) this resolves non-null.
export const getCheckoutChrome = unaryRpc({
  name: "getCheckoutChrome",
  input: getCheckoutChromeInput,
  output: getCheckoutChromeOutput,
});
